import { combineReducers } from "redux";

import Current from "./Current";
import Employee from "./Employee";
import Type from "./Type";
import Specialization from "./Specialization";
import Direction from "./Direction";
import City from "./City";

export default combineReducers({
  Current,
  Employee,
  Type,
  Specialization,
  Direction,
  City,
});
